import type { RouteObject } from 'react-router'

import { ProjectPage } from '@/features/projects/ProjectPage'

export const routes: RouteObject[] = [{ path: 'projects/:key', element: <ProjectPage /> }]
